import Image from "next/image";
import { INSTRUCTOR_AVATAR_FALLBACK } from "../helpers/constants";

const InstructorAvatar = ({
  photo,
  className,
  style,
}: {
  photo: string | null | undefined;
  className?: string;
  style?: React.CSSProperties;
}) => {
  const src = photo || INSTRUCTOR_AVATAR_FALLBACK;
  return (
    <div className={className} style={style}>
      <Image
        src={src}
        fill
        alt="instructors"
        className="rounded-full object-cover"
      />
    </div>
  );
};

export default InstructorAvatar;
